<template>
  <div class="wrapper">
    <div class="popupContent">
      <AppEditableTextarea
        ref="nameEditor"
        :value="locationName"
        :editing="editing"
        :disabled="readonly"
        @edit="toEditMode"
        @apply="applyLocationName"
        class="name"
      />
      <div v-if="!readonly" class="popupContentToolbar">
        <AppEditButton
          :editing="editing"
          @onEditClick="toEditMode"
          @onSaveClick="exitEditMode"
        />
        <AppUndoButton ref="nameUndo" :name="locationName" @pop="undoName" />
      </div>
    </div>
    <div class="popupFooter">
      <AppInactiveSwitch
        :status="isSwitchActive"
        :disabled="readonly"
        @change="onSwitchChange($event)"
        with-label
      />
      <AppDeleteButton
        v-if="!readonly"
        :click-handler="deleteLocation"
        with-label
      />
    </div>
  </div>
</template>

<script>
import AppEditableTextarea from '@/components/App/AppEditableTextarea'
import AppEditButton from '@/components/App/AppEditButton'
import AppInactiveSwitch from '@/components/App/AppInactiveSwitch'
import AppDeleteButton from '@/components/App/AppDeleteButton'
import AppUndoButton from '@/components/App/AppUndoButton'
import { mapActions } from 'vuex'
export default {
  name: 'SimulationContentDeliveryContentLayerWrapperPopup',
  components: {
    AppDeleteButton,
    AppInactiveSwitch,
    AppEditButton,
    AppEditableTextarea,
    AppUndoButton,
  },
  props: {
    location: {
      type: Object,
      default: () => {},
    },
    deliverySetting: {
      type: Object,
      default: () => {},
    },
    selectedGroup: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editing: false,
    }
  },
  computed: {
    locationName() {
      return this.location.name
    },
    isSwitchActive() {
      return this.location.status === 'active'
    },
    isActive: {
      get() {
        return this.location.isActive()
      },
    },
  },
  methods: {
    ...mapActions('simulation', {
      updateSelectedLocation: 'UPDATE_SELECTED_LOCATION',
    }),
    toEditMode() {
      this.editing = true
      this.$nextTick(() => {
        const targetTextarea = document.getElementById('editName')
        targetTextarea.focus()
      })
    },
    onSwitchChange(nextStatus) {
      this.location.updateStatus(nextStatus)
    },
    applyLocationName({ value }) {
      this.editing = false
      if (value !== this.location.name) {
        this.$refs.nameUndo.push(value)
        this.location.name = value
      }
    },
    updatePointName(name) {
      this.updateSelectedLocation({ ...this.selectedLocation, name })
    },
    exitEditMode() {
      this.$refs.nameEditor.applyName()
    },
    undoName(name) {
      this.location.name = name
      this.updateSelectedLocation({ ...this.selectedLocation, name })
    },
    deleteLocation() {
      this.selectedGroup.removeLocationPoint(this.location.id)
    },
  },
}
</script>

<style scoped>
.wrapper {
  position: relative;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 0;
}
.popupContent {
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 95px;
}

.popupContentToolbar {
  width: 40px;
}

.popupFooter {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0 10px;
}
.name {
  flex: 1;
  padding: 10px;
}

.isActive ::v-deep .v-icon {
  display: none;
}
</style>
